import { getHostName, convertToUTC } from "../utils";

export async function fetchHomeInfo(startDate, functionType) {
  const data = await fetch(
    `${getHostName()}/api/homedata/?format=json&startdate=${convertToUTC(startDate)}&functiontype=${functionType}`
  );
  return await data.json();
}
